<template>
  <div id="testing" class="page-layout__inner">
    <div :class="'page-layout__filter' + (filterSettings.visible ? '' : ' w-auto')">
      <section :class="'section  section--shadow-0  section--p-0' + (filterSettings.visible ? ' h-100' : '')">
        <button @click="filterSettings.visible = true" :class="'section__filter-btn' + (filterSettings.visible ? ' section__filter-btn--hidden' : '')">
          <svg class="section__filter-icon">
            <use xlink:href="#icon__filter"></use>
          </svg>
        </button>
        <div :class="'section__filter' + (filterSettings.visible ? '' : ' section__filter--hidden')">
          <div class="section__header">
            <h3 class="section__title">
              <svg class="section__filter-icon">
                <use xlink:href="#icon__filter"></use>
              </svg>
              {{ getTranslation('filter') }}
            </h3>

            <div class="section__controls">
              <div class="section__controls-group">
                <a @click="filterSettings.visible = false" class="btn  btn--xs  btn--control  js-filterHider" href="javascript:void(0)">
                  {{ getTranslation('hide') }}</a>
                <a class="btn  btn--xs  btn--control" href="javascript:void(0)" @click="resetFilter()">
                  {{ getTranslation('reset') }}</a>
              </div>
            </div>
          </div>
          <div class="section__body">
            <div class="form__group">
              <label class="form__label  form__label--block">{{ getTranslation('search') }}</label>
              <div class="field-advanced">
                <form method="post" @submit.prevent="fetchTests">
                  <div class="field-advanced__inner">
                    <div class="field-advanced__field-wrap">
                      <input v-model="filterForm.query" class="field  field--full-width  field--bg-grey  js-borderOnFocus" type="text" :placeholder="getTranslation('search')">
                    </div>
                    <div class="field-advanced__right">
                      <button class="btn  btn--square  btn--main">
                        <svg class="btn__icon">
                          <use xlink:href="#icon__search"></use>
                        </svg>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="form__group">
              <label class="form__label  form__label--block">{{ getTranslation('type') }}</label>
              <div class="list-group">
                <a @click="selectType(type.id)" v-for="type in types" href="javascript:void(0)" :class="{'active' : type.id===selectTypeId}" class="list-group-item d-flex justify-content-between align-items-center">
                  {{ type.title }}
                  <span class="badge badge-pill" :class="{'badge--warning': type.questionCount > 0,'badge--accent': type.questionCount < 1 }">
                    {{ type.questionCount }}</span>
                </a>
              </div>
            </div>
            <div class="form__group">
              <label class="form__label  form__label--block">{{ getTranslation('limit') }}</label>
              <label class="checkbox  checkbox--inline">
                <input class="checkbox__input" type="checkbox" v-model="filterForm.minLimit">
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">{{ getTranslation('minActiveQuestionLimit_filter') }}</span>
              </label>
            </div>
            <div class="form__group">
              <label class="form__label  form__label--block">{{ getTranslation('status') }}</label>
              <label v-for="stat in statuses" class="checkbox  checkbox--inline">
                <input class="checkbox__input" type="checkbox" v-model="filterForm.status" :value="stat.id">
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">{{ stat.title }}</span>
              </label>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="page-layout__content">
      <p class="page-layout__descr  text">{{ getTranslation('foundWithQuantity', pagination.total) }}</p>
      <div class="page-layout__group">
        <section class="section">
          <div class="section__body">
            <table class="table-3 table-borderless">
              <thead class="table-3__head">
              <tr class="table-3__row">
                <th class="table-3__cell  table__hcell" style="width: 45%">{{ getTranslation('title') }}</th>
                <th class="table-3__cell  table__hcell" style="width: 30%">{{ getTranslation('type') }}</th>
                <th class="table-3__cell  table__hcell" style="width: 10%">{{ getTranslation('questionMinLimit') }}</th>
                <th class="table-3__cell  table__hcell" style="width: 30%">{{ getTranslation('activeQuestionCount') }}
                </th>
                <th class="table-3__cell  table__hcell" style="width: 30%">{{ getTranslation('documentCode') }}</th>
                <th class="table-3__cell  table__hcell" style="width: 15%">{{ getTranslation('status') }}</th>
                <th class="table-3__cell  table__hcell" style="width: 0.2%"></th>
              </tr>
              </thead>
              <tbody class="table-3__body">
              <tr v-for="(item,key) in  tests" v-bind:key="key" class="table-3__row" :class="{'text--danger text--bold':item.questionCount < 1 && item.status}">
                <td class="table-3__cell">
                  <router-link :to="{ name: 'api.testing.get', params: { id: item.id } }">{{ item.title }}</router-link>
                </td>
                <td class="table-3__cell">
                  {{ getTypeLocale(item.type) }}
                </td>
                <td class="table-3__cell">
                  {{ item.minLimit }}
                </td>
                <td class="table-3__cell">
                  {{ item.activeQuestionCount }}
                </td>
                <td class="table-3__cell">
                  {{ item.documentCode }}
                </td>
                <td class="table-3__cell">
                  <span>{{ item.statusTitle }}</span>
                </td>
                <td class="table-3__cell">
                  <ActionsComponent v-on:delete="deleteItem(item.id)" :has-delete="false" v-on:edit="initUpdate(item)"></ActionsComponent>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
      <div class="page-layout__pagination" v-if="pagination.total && pagination.lastPage > 1">
        <pagination :pagination="pagination" @change="()=>{fetchTests();this.$scrollTo('#testing');}" v-model="filterForm.page"></pagination>
      </div>
    </div>
    <!--  modal  -->
    <modal
        v-model="showModal"
        :modal-title="edit === true ? getTranslation('edit'):getTranslation('add')"
        :ok-button-label="getTranslation('save')"
        :cancel-button-label="getTranslation('cancel')"
        :alert-class="'min-width-500'"
        @ok-button-click="save"
        @cancelButtonClick="reset"
        @input="reset"
    >
      <form class="form w-100">
        <span class="text-danger">* {{ getTranslation('required') }}</span>
        <div class="form__group">
          <label class="form__label   form__label--block">{{ getTranslation('title') }}<span class="required">*</span></label>
          <input class="field field--full-width" :class="{'field--error': $v.form.titleRu.$error}" v-model.trim="form.titleRu" type="text">
          <div v-if="$v.form.titleRu.$error" class="form__error">
            <span class="required">*</span></div>
        </div>
        <div class="form__group">
          <label class="form__label   form__label--block">{{ getTranslation('titleKy') }}<span class="required">*</span></label>
          <input class="field field--full-width" :class="{'field--error': $v.form.titleKy.$error}" v-model.trim="form.titleKy" type="text">
          <div v-if="$v.form.titleKy.$error" class="form__error">
            {{ getTranslation('requiredField') }}<span class="required">*</span></div>
        </div>
        <div class="form__group">
          <label class="form__label   form__label--block">{{ getTranslation('type') }}<span class="required">*</span></label>
          <v-select
              v-model="form.type"
              :options="types"
              label="title"
              @search:blur="$v.form.typeId.$touch()"
              :class="{'field--error':$v.form.typeId.$error}"
          />
          <div v-if="$v.form.typeId.$error" class="form__error">{{ getTranslation('requiredField') }}<span class="required">*</span></div>
        </div>
        <div class="form__group">
          <label class="form__label   form__label--block" for="documentCode">{{ getTranslation('questionMinLimit') }}
            <span class="text-danger">*</span></label>
          <input disabled v-model="form.minLimit" id="minLimit" min="1" class="field field--full-width" type="number"/>
          <div v-if="$v.form.minLimit.$error" class="form__error">{{ getTranslation('requiredField') }}<span class="required">*</span></div>
        </div>
        <div class="form__group">
          <label class="form__label   form__label--block" for="documentCode">{{ getTranslation('documentCode') }}</label>
          <input v-model="form.documentCode" id="documentCode" min="0" class="field field--full-width" type="number"/>
        </div>
        <div v-if="form.typeId === TEST_TYPE_MAIN" class="row">

          <div class="form__group col-md-6">
            <label class="form__label">{{ getTranslation('positionType') }}</label>
            <div class="checkbox-group  form__group">
              <label class="checkbox types-checkbox">
                <input v-model="regPostAll" class="checkbox__input" type="checkbox"/>
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label text--bold">{{ getTranslation('all') }}</span>
              </label>
            </div>
            <div class="checkbox-group  form__group">
              <label class="checkbox types-checkbox" v-for="regType in registerPostTypes" v-bind:key="regType.id">
                <input v-model="form.registerPostTypeIds" :id="'rg-'+regType.id" class="checkbox__input" type="checkbox" :value="regType.id"/>
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">{{ regType.title }}</span>
              </label>
            </div>
          </div>
          <div class="form__group col-md-6">
            <label class="form__label">{{ getTranslation('serviceType') }}</label>
            <div class="checkbox-group  form__group">
              <label class="checkbox types-checkbox">
                <input v-model="postAll" class="checkbox__input" type="checkbox"/>
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label text--bold">{{ getTranslation('all') }}</span>
              </label>
            </div>
            <div class="checkbox-group  form__group">
              <label class="checkbox types-checkbox" v-for="positionType in positionTypes" v-bind:key="positionType.id">
                <input v-model="form.positionTypeIds" :id="'rp-'+positionType.id" class="checkbox__input" type="checkbox" :value="positionType.id"/>
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">{{ positionType.title }}</span>
              </label>
            </div>
          </div>
          <div class="form__group col-md-6">
            <label class="form__label">{{ getTranslation('postGroup') }}</label>
            <div class="checkbox-group  form__group">
              <label class="checkbox types-checkbox">
                <input v-model="postGroupAll" class="checkbox__input" type="checkbox"/>
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label text--bold">{{ getTranslation('all') }}</span>
              </label>
            </div>
            <div class="checkbox-group  form__group">
              <label class="checkbox types-checkbox" v-for="postGroup in postGroups" v-bind:key="postGroup.id">
                <input v-model="form.postGroupIds" class="checkbox__input" type="checkbox" :value="postGroup.id"/>
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">{{ postGroup.title }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form__group">
          <label class="checkbox  checkbox--inline">
            <input class="checkbox__input" type="checkbox" v-model="form.status" :class="{'field--error':$v.form.status.$error}">
            <span class="checkbox__indicator  checkbox__indicator--inline"></span>
            <span class="checkbox__label">{{ getTranslation('status') }}</span>
            <span class="required">*</span>
          </label>
          <div v-if="$v.form.status.$error" class="form__error">
            {{ getTranslation('requiredField') }}<span class="required">*</span></div>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import ActionsComponent from "../../../components/shared/ActionsComponent";
import required from "vuelidate/lib/validators/required";
import testingMixin from "./mixins/testing";

export default {
  name: "Index",
  mixins: [testingMixin],
  components: {
    ActionsComponent,
  },
  data() {
    return {
      edit: false,
      showModal: false,
      selectTypeId: this.$route.query.typeId || '',
      filterSettings: {
        visible: true
      },
    }
  },

  updated() {

    let actions = [];
    if (this.hasPermission('api.testing.create'))
      actions.push({
        label: this.getTranslation('addTest'),
        action: this.setModal,
        icon: {
          icon: '#icon__square-add'
        }
      });

    this.setHeadings({
      title: this.getTranslation('testingTypes'),
      actions: actions
    });
  },
  created() {
    this.fetchFormOptions(true);
    this.fetchTests();
  },
  watch: {
    'form.type'(val) {
      if (val) {
        this.form.minLimit = val.QUESTION_MIN_LIMIT;
        this.form.typeId = val.id;
      }
    },
    'regPostAll'(val) {
      if (val && this.form.typeId === this.TEST_TYPE_MAIN) {
        for (let item of this.registerPostTypes) {
          if (this.form.registerPostTypeIds.indexOf(item.id) < 0)
            this.form.registerPostTypeIds.push(item.id)
        }
      } else
        this.form.registerPostTypeIds = [];
    },
    'postGroupAll'(val) {
      if (val && this.form.typeId === this.TEST_TYPE_MAIN) {

        for (let item of this.postGroups)
          if (this.form.postGroupIds.indexOf(item.id) < 0)
            this.form.postGroupIds.push(item.id);
      } else
        this.form.postGroupIds = [];
    },
    'postAll'(val) {
      if (val && this.form.typeId === this.TEST_TYPE_MAIN) {
        for (let item of this.positionTypes) {
          if (this.form.positionTypeIds.indexOf(item.id) < 0)
            this.form.positionTypeIds.push(item.id);
        }
      } else
        this.form.positionTypeIds = [];
    },
    'filterForm.status'() {
      this.fetchTests();
    },
    'filterForm.minLimit'() {
      this.fetchTests();
    },
    'selectTypeId'() {
      this.fetchTests();
    }
  },
  methods: {
    updateItem() {
      this.axios.put(this.$config.urls.testing.fetchTest.url.replace(':id', this.form.id), this.form).then(response => {
        this.showModal = false;
        this.reset();
        this.snotifySuccess('updateSuccessMsg');
        this.fetchTests();
      }).catch(() => {
      });
    },
    save() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid)
        return this.snotifyError('wrongFormMsg');

      if (!this.form.documentCode)
        this.form.documentCode = null;


      if (this.edit)
        this.updateItem();
      else {
        this.axios.post(this.$config.urls.testing.fetchTests.url, this.form).then(response => {
          if (response.data.status === true) {
            this.snotifySuccess('saveSuccessMsg');
            this.showModal = false;
            this.$router.push({name: 'api.testing.get', params: {id: response.data.data.id}});
          }
        }).catch(() => {
        })
      }

    },
    initUpdate(testing) {
      this.edit = true;
      this.form.titleRu = testing.titleRu;
      this.form.titleKy = testing.titleKy;
      this.form.id = testing.id;
      this.form.typeId = testing.type.id;
      this.form.type = this.types.filter(item=>item.id===testing.type.id)[0];
      this.form.documentCode = testing.documentCode;
      this.form.status = testing.status;
      this.form.minLimit = testing.minLimit;

      this.form.registerPostTypeIds = [];
      this.form.positionTypeIds = [];
      this.form.postGroupIds = [];

      if (testing.typeId === this.TEST_TYPE_MAIN) {

        for (let item of testing.postGroups) {
          if (this.form.postGroupIds.indexOf(item.resourceId) < 0)
            this.form.postGroupIds.push(item.resourceId);
        }

        for (let item of testing.registerPostTypes) {
          if (this.form.registerPostTypeIds.indexOf(item.resourceId) < 0)
            this.form.registerPostTypeIds.push(item.resourceId);
        }

        for (let item of testing.positionTypes) {
          if (this.form.positionTypeIds.indexOf(item.resourceId) < 0)
            this.form.positionTypeIds.push(item.resourceId);
        }

        if (this.form.positionTypeIds.length === this.positionTypes.length && this.form.positionTypeIds.length !== 0)
          this.postAll = true;
        else if (this.form.positionTypeIds.length === 0)
          this.postAll = false;

        if (this.form.registerPostTypeIds.length === this.registerPostTypes.length && this.form.registerPostTypeIds.length !== 0)
          this.regPostAll = true;
        else if (this.form.registerPostTypeIds.length === 0)
          this.regPostAll = false;


        if (this.form.postGroupIds.length === this.postGroups.length && this.form.postGroupIds.length !== 0)
          this.postGroupAll = true;
        else if (this.form.postGroupIds.length === 0)
          this.postGroupAll = false;

      } else {
        this.form.registerPostTypeIds = [];
        this.form.positionTypeIds = [];
        this.form.postGroupIds = [];
      }

      this.setModal();
    },
    setModal() {
      this.showModal = true;
      if (!this.edit)
        this.reset();
    },
    reset() {
      this.$v.$reset();
      this.edit = false;
      this.form.titleKy = '';
      this.form.titleRu = '';
      this.form.documentCode = '';
      this.form.id = null;
      this.form.status = true;
      this.form.typeId = '';
      this.form.type = null;
      this.form.minLimit = 1;
      this.form.registerPostTypeIds = [];
      this.form.positionTypeIds = [];
      this.form.postGroupIds = [];
    },
    deleteItem(testId) {
      this.$snotify.confirm(this.getTranslation('deleteConfirmMsg'), {
        //timeout: 5000,
        showProgressBar: false,
        closeOnClick: false,
//                    pauseOnHover: true,
        backdrop: 0.5,
        buttons: [
          {
            text: this.getTranslation('yes'), action: (toast) => {
              this.axios.delete(this.$config.urls.testing.fetchTest.url.replace(':id', testId))
                  .then(() => {
                    this.fetchTests();
                    this.$snotify.remove(toast.id);
                    setTimeout(() => {
                      this.snotifySuccess('deleteSuccessMsg');
                    });
                  }).catch(() => {
              });
            }, bold: true
          },
          {text: this.getTranslation('no'), action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    selectType(typeId) {
      if (typeId) {
        this.selectTypeId = typeId;
        this.filterForm.page = 1;
        this.filterForm.typeId = typeId;
      }
    },
    selectStatus(status) {
      let id = parseInt(status.id);
      let stat = false;
      if (id === 1)
        stat = true;
      if (!this.filterForm.status.includes(stat))
        this.filterForm.status.push(stat);
      this.fetchTests();
    },

    getTypeLocale(type) {
      let kg = 'kg';
      let ru = 'ru';
      let locale = this.currentLocale.toLowerCase();
      if (locale.includes(kg)) {
        return type.titleKg;
      }
      if (locale.includes(ru))
        return type.titleRu;
    },
    resetFilter() {
      this.$router.replace({
        query: {}
      }).catch(() => {
      });
      this.filterForm = {
        page: 1,
        status: [],
      };
      this.selectTypeId = '';
    }
  },
  validations: {
    form: {
      titleRu: {
        required
      },
      titleKy: {
        required
      },
      status: {
        required
      },
      typeId: {
        required
      },
      minLimit: {
        required
      }
    }
  }
}
</script>

<style scoped>
.types-checkbox {
  position: relative;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: row;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: nowrap !important;
  margin-right: 15px;
  margin-bottom: 8px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
}

.list-group-item-action {
  width: 100%;
  color: #303030;
  text-align: inherit;
}

.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.ui-kit__subtitle {
  position: relative;
  margin-bottom: 15px;
  padding-bottom: 5px;
  color: #000;
  font-weight: 500;
  font-size: 20px;
  line-height: 48px;
}

.ui-kit__subtitle::after {
  content: '';
  display: block;
  position: absolute;
  bottom: 0;
  width: 40px;
  height: 4px;
  background-color: #EC3765;
}
</style>
